export default __webpack_public_path__ + "static/media/BCH.e669cc33.svg";